export var VIDEO_END_OPTIONS;
(function (VIDEO_END_OPTIONS) {
    VIDEO_END_OPTIONS[VIDEO_END_OPTIONS["SHOW_VIDEO_COVER"] = 1] = "SHOW_VIDEO_COVER";
    VIDEO_END_OPTIONS[VIDEO_END_OPTIONS["PLAY_NEXT_VIDEO"] = 2] = "PLAY_NEXT_VIDEO";
    VIDEO_END_OPTIONS[VIDEO_END_OPTIONS["OPEN_ACTION_CARDS"] = 3] = "OPEN_ACTION_CARDS";
})(VIDEO_END_OPTIONS || (VIDEO_END_OPTIONS = {}));
//# sourceMappingURL=video-end-options.js.map